import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { diseasesValidator } from '@shared/validators/diseases-validator';

export const venisafeSampleValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        sampleType: {
          validators: [Validators.required],
        },
      },
    },
  },
};
